import {
  mergeConfig,
  wrapAsDerivedFromMeasurementsConfig as wrap,
} from 'Components/Worksheets/Core/Helpers/configHelpers';
import getMoistureContentDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';

const getDerivedFromMeasurementsConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Masses.WashedDryMass`]: wrap([
        `${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.ContainerMass`,
        `${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
      ]),
    },
    getMoistureContentDerivedFromMeasurementsConfig(`${prefix}.Masses.MeasuredWashedConstantDryMass`)
  );

export default getDerivedFromMeasurementsConfig;
